import { formatMoney } from "../lib/formatMoney.js";
import { fetchJson } from "../lib/fetchJson.js";
import { showCartErrorToast } from "../lib/toast.js";
import { setElementInnerHTML, setElementInnerText, setElementValue } from "../lib/utils.js";
import { showCartSuccessModal } from "./cartSuccessModal.js";

interface Variant {
  id: number
  name: string
  option1: string
  option2: string
  option3: string
  inventory_management: string
  inventory_policy: string
  inventory_quantity: number
  price: number
}
interface Product {
  handle: string
  variants: Variant[]
}
export class FFAddProduct extends HTMLElement {

  productId: string | null
  productMax: number | null
  defaultVariantId: number | null
  productData?: Product
  DOM: {
    addButton: HTMLElement | null
    options: NodeListOf<HTMLInputElement>
    optionInputs: NodeListOf<HTMLInputElement>
    qty: HTMLInputElement | null
    summary: HTMLElement | null
    summaryName: HTMLElement | null
    summaryPrice: HTMLElement | null
  }

  constructor(){
    super();
    this.DOM = {
			addButton: this.querySelector('.js-addButton'),
			options: this.querySelectorAll('ff-select'),
			optionInputs: this.querySelectorAll('ff-select .js-value'),
			qty: this.querySelector('.qty'),
			summary: this.querySelector('.summary'),
			summaryName: this.querySelector('.summary .variantName'),
			summaryPrice: this.querySelector('.summary .price'),
		}
		this.productId = this.getAttribute('product-id');
    const productMax = this.getAttribute('max-quantity')
		this.productMax = productMax ? parseInt(productMax) : null;
    const defaultVariantId = this.getAttribute('default-variant-id')
		this.defaultVariantId = defaultVariantId ? parseInt(defaultVariantId) : null;
    if( !this.productId ) return
    const dataEl = document.getElementById(`productJson-${this.productId}`)
    if( !(dataEl instanceof HTMLElement )) return
	  this.productData = JSON.parse( dataEl.innerHTML ) as Product;
		this.events();
  }
	
	events(){
		this.DOM.addButton?.addEventListener('click', this.addClick.bind(this) )

		this.DOM.qty?.addEventListener('keyup', this.optionChange.bind(this));
		this.DOM.qty?.addEventListener('change', this.optionChange.bind(this));

    this.DOM.options.forEach(el => {
      el.addEventListener('optionChange', this.optionChange.bind(this))
    })
	}

	optionChange(){
		const selectedOptions = this.getOptions();
		const variant = this.getVariant( selectedOptions );
    if( !variant ) return
		let qty = parseInt(this.DOM.qty?.value || "0");

		if( variant.inventory_management === "shopify" && variant.inventory_policy === 'deny' ){
			if( variant.inventory_quantity < qty ){
				qty = variant.inventory_quantity
        setElementValue(this.DOM.qty, qty)
			}

			if( !this.productMax || this.productMax > variant.inventory_quantity ){
				this.DOM.qty?.setAttribute('data-max', variant.inventory_quantity ? String(variant.inventory_quantity) : "" );
			}else{
				this.DOM.qty?.setAttribute('data-max', this.productMax ? String(this.productMax) : "" );
			}
		}else{
			this.DOM.qty?.removeAttribute('data-max');
		}

		this.DOM.summary?.classList.add('active');
		setElementInnerHTML(this.DOM.summaryName, '<p><strong>' + variant.name + '</strong> &times;' + qty + '</p>');
		setElementInnerText(this.DOM.summaryPrice, formatMoney( variant.price * qty, "${{amount}}" ));
	}

	addClick(){
		const selectedOptions = this.getOptions();
		let variantId = this.defaultVariantId;

		if( selectedOptions.length > 0 ) {
			const variant = this.getVariant( selectedOptions );
      if( variant ){
        variantId = variant.id;
      }
		}

		const qty = this.DOM.qty?.value;

    if( !variantId ) return
		this.addVariantToCart( variantId, qty ? parseInt(qty) : 0 )
	}

	async addVariantToCart( variantId: number, qty: number ){
    try {
			await fetchJson('/cart/add.js', {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
				},
				body: JSON.stringify({
					items: [{
						quantity: qty,
						id: variantId,
        	}]
				}),
			})
      this.addSuccess()
		} catch (_error) {
			showCartErrorToast()
		}
	}	

	getOptions(){
		return [...this.DOM.optionInputs].map( el => el.value)
	}

  optionsMatch( values: string[], variant: Variant ){
    return values.reduce( (acc, cur, i) => {
      const optionKey = `option${i+1}` as keyof Variant
      if(cur !== variant[optionKey]){
        return false
      }
      return acc
    }, true)
  }

	getVariant( selectedOptions: string[] ){
    return this.productData?.variants.find( el => {
      return this.optionsMatch(selectedOptions, el)
    })
	}

	addSuccess(){
		showCartSuccessModal(this.productData?.handle || "")
	}

}

customElements.define('ff-add-product', FFAddProduct);